/**
 * THE recipe of a hand-written control that is off, for the few controls the package `Button`
 * cannot be (a gutter icon, a segment): grey ground, grey border, `gray-600` ink - 4.55:1, so the
 * label stays readable at the very moment one needs to read why the control does not answer.
 * An opacity would only PALE a filled button, and the dead button would draw the click it refuses.
 */
export const DISABLED_INERT =
  'disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-600';
